import * as RADIX__context_menu from '@radix-ui/react-context-menu';

export const UI_PRIMITIVE__context_menu_root = RADIX__context_menu.Root;

export const UI_PRIMITIVE__context_menu_trigger = RADIX__context_menu.Trigger;

export const UI_PRIMITIVE__context_menu_group = RADIX__context_menu.Group;

export const UI_PRIMITIVE__context_menu_portal = RADIX__context_menu.Portal;

export const UI_PRIMITIVE__context_menu_sub = RADIX__context_menu.Sub;

export const UI_PRIMITIVE__context_menu_radio_group = RADIX__context_menu.RadioGroup;
